import React, { Fragment } from 'react';
import classNames from 'classnames';

import propTypes from 'prop-types';
import PriceSpan from 'common/components/formatters/PriceSpan';

export default class VariantPrice extends React.Component {
  static propTypes = {
    baseAmount: propTypes.number.isRequired,
    isMembershipOrder: propTypes.bool.isRequired,
    membershipDiscountRate: propTypes.number.isRequired,
    isSubscribable: propTypes.bool.isRequired,
    commitmentMonths: propTypes.number,
    commitmentPrice: propTypes.number,
    userAmount: propTypes.number.isRequired,
  };

  get isMembershipPrice() {
    const { isSubscribable, isMembershipOrder, commitmentMonths } = this.props;
    const isSubscribableInMembershipOrder = isSubscribable && isMembershipOrder;
    return isSubscribableInMembershipOrder && !commitmentMonths;
  }

  get amount() {
    const { commitmentPrice, membershipDiscountRate, userAmount } = this.props;

    if (this.props.commitmentMonths) {
      return commitmentPrice;
    }

    return this.isMembershipPrice
      ? userAmount * (1 - membershipDiscountRate)
      : userAmount;
  }

  render() {
    const { priceUnitString, commitmentPrice } = this.props;

    const displayUnitString =
      commitmentPrice && priceUnitString ? `/${priceUnitString}` : '';

    return (
      <Fragment>
        <PriceSpan
          className={classNames({
            'autoship-text': this.props.commitmentMonths,
          })}
          amount={this.amount}
        />
        <span className={classNames('text--small')}>{displayUnitString}</span>
      </Fragment>
    );
  }
}
